import React from "react";
import { TCText } from "../TCText/TCText";
import { Colors } from "../../utils/colors";

type props = {
  loading: boolean;
  text: string;
};

export const OverlayLoadingIndicator: React.FC<props> = ({ loading, text }) => {
  return loading ? (
    <div
      style={{
        backgroundColor: "white",
        borderRadius: 16,
        padding: 20,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "70%",
        height: 122,
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
        position: "fixed",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        margin: "auto",
        flexDirection: "column",
        zIndex: 10001,
        maxWidth: "300px",
      }}>
      <div
        className="spinner-border custom-spinner"
        style={{ color: Colors.green }}
        role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      <TCText style={{ fontWeight: 500, fontSize: 12 }} value={text} />
    </div>
  ) : null;
};
